import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 60%;
  right: 0;
  transform: translateY(-50%);
`;
